import React from "react";

const Pesq = ({ menu = true, search = true }) => {
  return (
    <div
      className="d-flex flex-row ps-0 ml-2 pe-xss-0 pe-md-2 align-items-center"
      id="header-row"
    >
      {menu && (
        <div className="p-4 d-sm-block">
          <button
            className="btn btn-outline-secondary"
            type="button"
            id="sidebarCollapse"
          >
            <i className="fa fa-align-justify" id="menu-icon"></i>
          </button>
        </div>
      )}

      <div className="p-4 ms-xss-auto ms-md-0" id="header-img-div">
        <a
          href="https://intelbras.com.br"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="./res/img/intelbras_marca.svg" alt="" id="header-img" />
        </a>
      </div>
      <div
        className="p-4 me-md-auto ms-md-0 ms-sm-auto mt-2 d-sm-block d-md-block d-xss-none"
        id="product-name-div"
      >
        <p className="h4 header-h4 fs-sm-6 fs-lg-4">Manual versão</p>
      </div>

      {search && (
        <div
          className="p-4 flex-nowrap text-nowrap ms-auto d-xs-none d-md-flex"
          id="header-search"
        >
          <button
            className="btn btn-primary buttonGap"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#search-offcanvas"
            aria-controls="search-offcanvas"
          >
            <span
              className="d-xss-none d-md-none d-sm-none d-xl-inline"
              style={{ color: "#fff" }}
            >
              Pesquisar
            </span>
            <i className="fa fa-search" style={{ color: "#fff" }}></i>
          </button>
        </div>
      )}

      <div
        className="offcanvas offcanvas-end"
        data-bs-scroll="true"
        data-bs-backdrop="false"
        id="search-offcanvas"
        aria-labelledby="offcanvasScrollingLabel"
      >
        <div className="offcanvas-header">
          <p className="h5 offcanvas-title" id="offcanvasScrollingLabel">
            Pesquisar tópicos
          </p>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            id="close-offcanvas"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div
            className="p-md-4 p-xss-0 pb-md-2 pt-md-0 pt-sm-0 d-md-block"
            id="search-bar"
          >
            <div className="d-flex justify-content-center">
              <div
                className="btn-toolbar d-flex justify-content-center"
                role="toolbar"
              >
                <div
                  className="btn-group col-sm-12 col-xss-8 col-md-8"
                  role="group"
                >
                  <input
                    type="text"
                    className="form-control"
                    name="searchBar"
                    id="searchBar"
                    placeholder="Buscar"
                  />
                </div>
                <div className="btn-group" role="group">
                  <button
                    data-search="next"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fa fa-long-arrow-down" aria-hidden="true"></i>
                  </button>
                  <button
                    data-search="prev"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fa fa-long-arrow-up" aria-hidden="true"></i>
                  </button>
                  <button
                    data-search="clear"
                    className="btn btn-outline-secondary"
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pesq;
